import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getVoting } from '../../redux/data/dataActions';
import { setPhoneNumber, setTermsAndConditions, setQuizUserSelection, setQuizSubmissionError, setQuizSubmissionSuccess } from '../../redux/data/dataSlice';
import config from "../../config/memberhubContents.json";
import ArrowLeft from "../../assets/images/arrow-left.svg";
import ArrowRight from "../../assets/images/arrow-right.svg";
import { useEffect, useState } from "react";

function QuizFooter(props) {
    const dispatch = useDispatch();
    const userSelections = useSelector(state => state.data.quizUserSelections);
    const quizCompleted = useSelector(state => state.data.quizSubmissionSuccess);
    const questions = props && props.questions;
    const currentQuestionIndex = props && props.current;
    const enabled = userSelections[currentQuestionIndex] &&
        userSelections[currentQuestionIndex].selected_answers &&
        userSelections[currentQuestionIndex].selected_answers.length > 0;
    const back = props && props.back;
    const next = props && props.next;
    const submit = props && props.submit;
    const first = currentQuestionIndex === 0;
    const last = currentQuestionIndex === questions.length - 1;
    const singleQuestion = questions.length === 1;
    const reviewing = currentQuestionIndex === questions.length;
    const pollMinProgressBarPct = 0.05;
    const pollMaxProgressBarPct = 0.9;
    const pollReviewingProgressBarPct = 0.95;
    const pollCompletedProgressBarPct = 1;
    const [currentPct, setCurrentPct] = useState(0);

    useEffect(() => {
        let pct = (() => {
            if (quizCompleted) return pollCompletedProgressBarPct;
            if (reviewing) return pollReviewingProgressBarPct;
            if (last) return pollMaxProgressBarPct;
            if (first) return pollMinProgressBarPct;

            if (props.current !== undefined && props.questions && props.questions.length > 0) {
                return ((props.current + 1) / props.questions.length);
            }

            return 0;
        })();

        setCurrentPct(pct * 100);
    }, [props, quizCompleted, first, last, reviewing]);

    return (
        <div className="modal-footer quiz-footer">
            {questions.length !== 1 &&
                <div className="modal-progress-bar">
                    <div className="progress-bar-text">{quizCompleted ? 'Complete' : reviewing ? 'Review' :
                        `${currentQuestionIndex + 1} of ${questions.length}`}</div>
                    <div className="progress-bar-container">
                        <div className="progress-bar-inner" style={{ width: `${currentPct}%` }}></div>
                    </div>
                </div>
            }
            <div className="modal-cta-group">
                { /* Completed */
                    quizCompleted &&
                    <Link
                        onClick={() => {
                            props.setShowModal(false);
                            dispatch(getVoting());
                            dispatch(setPhoneNumber(""));
                            dispatch(setTermsAndConditions(false));
                            dispatch(setQuizUserSelection([]));
                            dispatch(setQuizSubmissionSuccess(false));
                            dispatch(setQuizSubmissionError(null));
                        }}
                        className="modal-button-cta"
                        to={{ pathname: "/voting", search: window.location.search }}
                        data-track="click"
                        data-id="nba:membership-hub:dismiss"
                        data-section="voting"
                        data-type="dismiss">
                        {config.returnToBenefits}
                    </Link>
                }
                { /* Review */
                    !quizCompleted && reviewing &&
                    <>
                        <div
                            onClick={() => back()}
                            className="modal-button-cta"
                            data-track="click"
                            data-type="cta">
                            <img src={ArrowLeft} alt="Back" className="modal-icon" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
                            {config.back}
                        </div>
                        <div
                            onClick={submit}
                            className="modal-button-cta"
                            data-track="click"
                            data-id="nba:membership-hub:outbound:cta"
                            data-type="cta">
                            {config.submit}
                            <img src={ArrowRight} alt="Submit" className="modal-icon" style={{ width: '24px', height: '24px', marginLeft: '8px' }} />
                        </div>
                    </>
                }
                { /* Single Question */
                    !quizCompleted && singleQuestion &&
                    <div
                        onClick={submit}
                        className={`modal-button-cta ${!enabled ? 'disabled' : ''}`}
                        data-track="click"
                        data-id="nba:membership-hub:outbound:cta"
                        data-type="cta">
                        {config.submit}
                        <img src={ArrowRight} alt="Submit" className="modal-icon" style={{ width: '24px', height: '24px', marginLeft: '8px' }} />
                    </div>
                }
                { /* First Question in Multiple Question Quiz */
                    !quizCompleted && !singleQuestion && first &&
                    <div
                        onClick={() => next()}
                        className={`modal-button-cta ${!enabled ? 'disabled' : ''}`}
                        data-track="click"
                        data-type="cta">
                        {config.next}
                        <img src={ArrowRight} alt="Next" className="modal-icon" style={{ width: '24px', height: '24px', marginLeft: '8px' }} />
                    </div>
                }
                { /* Intermediate Question in Muliple Question Quiz */
                    !quizCompleted && !singleQuestion && !first && !reviewing &&
                    <>
                        <div
                            onClick={() => back()}
                            className={`modal-button-cta`}
                            data-track="click"
                            data-type="cta">
                            <img src={ArrowLeft} alt="Back" className="modal-icon" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
                            {config.back}
                        </div>
                        <div
                            onClick={() => next()}
                            className={`modal-button-cta ${!enabled ? 'disabled' : ''}`}
                            data-track="click"
                            data-type="cta">
                            {config.next}
                            <img src={ArrowRight} alt="Next" className="modal-icon" style={{ width: '24px', height: '24px', marginLeft: '8px' }} />
                        </div>
                    </>
                }
            </div>
        </div>
    );
}

export default QuizFooter;